import { HttpClient } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { Roles } from '@models/roles';
import { MatDialog } from '@angular/material';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/router";
import * as i3 from "@angular/material/dialog";
var AuthService = /** @class */ (function () {
    function AuthService(http, router, baseUrl, matDialog) {
        this.http = http;
        this.router = router;
        this.baseUrl = baseUrl;
        this.matDialog = matDialog;
        this.jwtHelperService = new JwtHelperService();
        this.apiUrl = '';
        this._examInProgress = false;
        this.apiUrl = this.baseUrl + "api/authentication";
    }
    Object.defineProperty(AuthService.prototype, "examInProgress", {
        get: function () {
            return this._examInProgress;
        },
        set: function (value) {
            console.log('%cExam in progress: ', 'color: #fa0', value);
            this._examInProgress = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "activity", {
        get: function () {
            var act = Number(localStorage.getItem('activity'));
            if (act === 0) {
                return Date.now();
            }
            return act;
        },
        set: function (value) {
            localStorage.setItem('activity', value.toString());
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "accessToken", {
        get: function () {
            return localStorage.getItem('token');
        },
        set: function (value) {
            if (value === null) {
                localStorage.removeItem('token');
            }
            else {
                localStorage.setItem('token', value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "refreshToken", {
        get: function () {
            return localStorage.getItem('refresh');
        },
        set: function (value) {
            if (value === null) {
                localStorage.removeItem('refresh');
            }
            else {
                localStorage.setItem('refresh', value);
            }
        },
        enumerable: true,
        configurable: true
    });
    AuthService.prototype.register = function (userRegisterModel) {
        return this.http.post(this.apiUrl + "/register", userRegisterModel);
    };
    AuthService.prototype.login = function (userLoginModel) {
        var _this = this;
        return this.http.post(this.apiUrl + "/login", userLoginModel).pipe(map(function (response) {
            // login successful if there's a jwt token in the response
            if (response && response.accessToken) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                _this.accessToken = response.accessToken;
                _this.setUser(response.user);
                // the jwt refresh token will wait until the access token is about to expire
                _this.refreshToken = response.refreshToken;
                _this.setIdleTimeout(_this.accessToken, Date.now());
            }
            return response.user;
        }));
    };
    AuthService.prototype.setIdleTimeout = function (token, activity) {
        // if there is an exam in progress, that is considered activity
        if (this.examInProgress) {
            activity = Date.now();
        }
        this.activity = activity;
        // how long ago was the last time a message was sent to the server?
        // we want to subtract that from the timeout.
        var last = Date.now() - activity;
        var next = this.jwtHelperService.getTokenExpirationDate(token).getTime() - Date.now();
        // and only set the timer if it's in the positives
        if (next > last + 1000) {
            this.idleTimer = setTimeout(this.scopeCall, next - last, this.refreshJwsToken, this, activity);
            console.log(new Date(Date.now() + next - last));
            return true;
        }
        else {
            console.log('Session expired');
            this.logoutNow();
            return false;
        }
    };
    AuthService.prototype.scopeCall = function (callback, $this) {
        var $params = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            $params[_i - 2] = arguments[_i];
        }
        callback.call.apply(callback, [$this].concat($params));
    };
    AuthService.prototype.refreshJwsToken = function (previous) {
        var _this = this;
        if (!this.accessToken)
            return;
        var activity = this.activity;
        var token = this.accessToken;
        var next = this.jwtHelperService.getTokenExpirationDate(token).getTime() - Date.now();
        if (activity > previous && next > 1000) {
            console.log('Waiting a little longer');
            this.idleTimer = setTimeout(this.scopeCall, next, this.refreshJwsToken, this, activity);
            return;
        }
        this.http
            .post(this.apiUrl + "/login/refresh", {
            accessToken: token,
            refreshToken: this.refreshToken
        })
            .pipe(catchError(function (error) {
            console.log('Failed to refresh token(2)');
            _this.logoutNow();
            return throwError(error);
        }))
            .subscribe(function (response) {
            if (response.accessToken) {
                console.log('Refreshing token');
                _this.accessToken = response.accessToken;
                _this.refreshToken = response.refreshToken;
                _this.setIdleTimeout(response.accessToken, activity);
            }
            else {
                console.log('Failed to refresh token(1)');
                _this.logoutNow();
            }
        });
    };
    AuthService.prototype.logout = function () {
        // Don't leave dialogs open.
        this.matDialog.closeAll();
        // remove user from local storage to log user out
        this.setUser(null);
        this.accessToken = null;
        // cancel the idle timer
        clearTimeout(this.idleTimer);
        this.idleTimer = null;
        this.refreshToken = null;
        return this.http.post(this.apiUrl + "/logout", {}, {});
    };
    AuthService.prototype.logoutNow = function () {
        var _this = this;
        this.logout().subscribe(function (_) { return _this.router.navigate(['/login']); });
    };
    AuthService.prototype.loggedIn = function () {
        if (this.getUser() === null) {
            return false;
        }
        else if (this.jwtHelperService.isTokenExpired(this.accessToken)) {
            return false;
        }
        else if (!this.idleTimer) {
            return this.setIdleTimeout(this.accessToken, Date.now());
        }
        return true;
    };
    AuthService.prototype.roleMatch = function (allowedRoles) {
        var isMatch = false;
        var userRoles = this.getUserRoles();
        allowedRoles.forEach(function (element) {
            if (userRoles.includes(element)) {
                isMatch = true;
                return;
            }
        });
        return isMatch;
    };
    AuthService.prototype.getUser = function () {
        return JSON.parse(localStorage.getItem('user'));
    };
    AuthService.prototype.setUser = function (value) {
        if (value === null) {
            localStorage.removeItem('user');
        }
        else {
            localStorage.setItem('user', JSON.stringify(value));
        }
    };
    AuthService.prototype.getUserId = function () {
        var user = this.getUser();
        if (user) {
            return user.id;
        }
        return null;
    };
    /**
     * For use by administrators to reset users' passwords for them
     * Resets a user's password to a randomly created password.  The
     * admin will need to forward the new password to the user.
     * @param userId The ID of the user whose password will be reset.
     */
    AuthService.prototype.resetPassword = function (userId) {
        return this.http.put(this.apiUrl + "/resetPassword", {}, {
            params: {
                userId: userId
            }
        });
    };
    /**
     * For use by users.
     * Request that an email be sent to this email address if the address is valid.
     * A code will be sent in the email that can be used to create a new password.
     * @param email The user's email address.
     */
    AuthService.prototype.forgotPassword = function (email, locale) {
        return this.http.put(this.apiUrl + "/forgotPassword", {}, {
            params: {
                email: email,
                locale: locale
            }
        });
    };
    /**
     * Enables users to change they're own password if they forgot it.
     * @param email Users email address
     * @param token The code the user received in their email
     * @param newPassword The new password the user just created.
     */
    AuthService.prototype.userResetPassword = function (email, token, newPassword) {
        return this.http.put(this.apiUrl + "/userResetPassword", {
            email: email,
            token: token,
            newPassword: newPassword
        });
    };
    AuthService.prototype.changePassword = function (passwords) {
        return this.http.put(this.apiUrl + "/changePassword", passwords);
    };
    AuthService.prototype.getToken = function () {
        return this.accessToken;
    };
    AuthService.prototype.isCurrentUserCandidate = function () {
        return this.userHasRole(Roles.candidate);
    };
    AuthService.prototype.isCurrentUserAdmin = function () {
        return this.userHasRole(Roles.admin);
    };
    AuthService.prototype.isCurrentUserEvaluator = function () {
        return this.userHasRole(Roles.evaluator);
    };
    AuthService.prototype.isCurrentUserThirdParty = function () {
        return this.userHasRole(Roles.thirdParty);
    };
    AuthService.prototype.setUserHasRegisteredForACertification = function () {
        var user = this.getUser();
        user.hasRegisteredForACertification = true;
        this.setUser(user);
    };
    AuthService.prototype.setUserHasCompletedDetails = function () {
        var user = this.getUser();
        user.hasMissingDetails = false;
        this.setUser(user);
    };
    AuthService.prototype.getDecodedToken = function () {
        if (this.accessToken === null)
            return null;
        return this.jwtHelperService.decodeToken(this.accessToken);
    };
    AuthService.prototype.userHasRole = function (role) {
        return this.getUserRoles().indexOf(role) >= 0;
    };
    AuthService.prototype.getUserRoles = function () {
        var token = this.getDecodedToken();
        return (token ? token.role : null);
    };
    AuthService.ngInjectableDef = i0.defineInjectable({ factory: function AuthService_Factory() { return new AuthService(i0.inject(i1.HttpClient), i0.inject(i2.Router), i0.inject("BASE_URL"), i0.inject(i3.MatDialog)); }, token: AuthService, providedIn: "root" });
    return AuthService;
}());
export { AuthService };
